exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-card-27mdN{--gap:12px;font-size:13px;padding:16px;display:flex;flex-direction:column;row-gap:var(--gap);border-bottom:var(--border)}.style-cssmodule-firstRow-2-myr{display:flex;justify-content:space-between;align-items:center}.style-cssmodule-secondRow-qCou6{display:flex}.style-cssmodule-fourthRow-2troK,.style-cssmodule-thirdRow-S1QlK{display:flex;line-height:1;align-items:center;gap:7px}.style-cssmodule-fifthRow-jjPqp,.style-cssmodule-seventhRow-2uBB8,.style-cssmodule-sixthRow-4nv-Q{display:flex;gap:var(--gap)}.style-cssmodule-bold-3eKNB{font-weight:700}.style-cssmodule-copyIcon-1HTVh{stroke:var(--color-night-gray6);display:grid;cursor:pointer}.style-cssmodule-usernameOrLicensePlate-3Nqw_{color:var(--color-night-gray8,#32435e);font-family:Roboto;font-size:16px;font-style:normal;line-height:20px;font-weight:400}.style-cssmodule-carpark-1shxi,.style-cssmodule-lastname-2oQTP{font-weight:600}.style-cssmodule-externalLink-KLpeb{display:flex;align-items:center;column-gap:15px}.style-cssmodule-inline-15ThK{display:flex;align-items:center;gap:10px}", ""]);

// exports
exports.locals = {
	"card": "style-cssmodule-card-27mdN",
	"firstRow": "style-cssmodule-firstRow-2-myr",
	"secondRow": "style-cssmodule-secondRow-qCou6",
	"thirdRow": "style-cssmodule-thirdRow-S1QlK",
	"fourthRow": "style-cssmodule-fourthRow-2troK",
	"fifthRow": "style-cssmodule-fifthRow-jjPqp",
	"sixthRow": "style-cssmodule-sixthRow-4nv-Q",
	"seventhRow": "style-cssmodule-seventhRow-2uBB8",
	"bold": "style-cssmodule-bold-3eKNB",
	"copyIcon": "style-cssmodule-copyIcon-1HTVh",
	"usernameOrLicensePlate": "style-cssmodule-usernameOrLicensePlate-3Nqw_",
	"lastname": "style-cssmodule-lastname-2oQTP",
	"carpark": "style-cssmodule-carpark-1shxi",
	"externalLink": "style-cssmodule-externalLink-KLpeb",
	"inline": "style-cssmodule-inline-15ThK"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/ParkingCard/style.cssmodule.css
// module id = 2556
// module chunks = 121